var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
        _c("div", { staticClass: "nk-block-between" }, [
          _c("div", { staticClass: "nk-block-head-content" }, [
            _c("h3", { staticClass: "nk-block-title page-title" }, [
              _vm._v(_vm._s(_vm.trans("configuration.configuration"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "nk-block-des text-soft" }, [
              _c("p", [_vm._v(_vm._s(_vm.trans("locale.locale")))]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "admin-config-layout admin-linear-page" },
        [
          _c("configuration-sidebar", { attrs: { menu: "locale" } }),
          _vm._v(" "),
          _c("div", { staticClass: "admin-config-panel" }, [
            _c(
              "div",
              {
                staticClass:
                  "admin-config-panel__inner admin-config-panel__inner--wide",
              },
              [
                _c("div", { staticClass: "admin-linear-head" }, [
                  _c("div", [
                    _c("span", { staticClass: "admin-linear-head__eyebrow" }, [
                      _vm._v("Localization"),
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "admin-linear-head__title" }, [
                      _vm._v(_vm._s(_vm.trans("locale.locale"))),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "admin-linear-head__description" }, [
                      _vm._v(
                        "Manage languages, add translation keys, and open module translations from one focused surface."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "admin-linear-stats" }, [
                    _c("div", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.trans("locale.locale_list"))),
                      ]),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.locales && _vm.locales.total
                              ? _vm.locales.total
                              : 0
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.trans("locale.module")))]),
                      _vm._v(" "),
                      _c("strong", [_vm._v(_vm._s(_vm.moduleCount))]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("show-tip", {
                  attrs: { module: "locale", tip: "tip_locale" },
                }),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "admin-config-list-section",
                    attrs: {
                      "aria-labelledby": "admin-config-locale-list-title",
                    },
                  },
                  [
                    _c(
                      "header",
                      {
                        staticClass:
                          "admin-config-list-head admin-config-list-head--split",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "admin-config-list-head__text" },
                          [
                            _c(
                              "h4",
                              {
                                staticClass: "admin-config-list-head__title",
                                attrs: { id: "admin-config-locale-list-title" },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.trans("locale.locale_list")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.locales && _vm.locales.total
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "admin-config-list-head__sub",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.trans(
                                            "general.total_result_found",
                                            { count: _vm.locales.total }
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm.locales
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "admin-config-list-head__sub admin-config-list-head__sub--empty",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.trans("general.no_result_found")
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "admin-config-list-head__actions" },
                          [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.modal-locale-add-word",
                                    modifiers: {
                                      "modal-locale-add-word": true,
                                    },
                                  },
                                ],
                                staticClass:
                                  "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                                attrs: { type: "button" },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.trans("locale.add_new_word")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.modal-locale-create",
                                    modifiers: { "modal-locale-create": true },
                                  },
                                ],
                                staticClass:
                                  "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                                attrs: { type: "button" },
                              },
                              [
                                _c("admin-icon", { attrs: { name: "plus" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.trans("general.add_new")) +
                                    "\n                        "
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.locales && _vm.locales.total
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "admin-list-table-card admin-config-list-card",
                          },
                          [
                            _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table admin-data-table admin-data-table--config-list admin-linear-table mb-0",
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(_vm.trans("general.name"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(_vm.trans("locale.locale"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass:
                                            "admin-table-actions-cell",
                                          attrs: { scope: "col" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.trans("general.actions"))
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.locales.data, function (locale) {
                                      return _c("tr", { key: locale.id }, [
                                        _c("td", [
                                          _c(
                                            "strong",
                                            {
                                              staticClass:
                                                "admin-linear-primary",
                                            },
                                            [_vm._v(_vm._s(locale.name))]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "admin-linear-code",
                                            },
                                            [_vm._v(_vm._s(locale.locale))]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "admin-table-actions-cell",
                                          },
                                          [
                                            _c(
                                              "table-row-action-dropdown",
                                              [
                                                _c(
                                                  "b-dropdown-item-button",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editLocale(
                                                          locale
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("admin-icon", {
                                                      attrs: { name: "pencil" },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.trans(
                                                            "general.edit"
                                                          )
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-dropdown-item",
                                                  {
                                                    attrs: {
                                                      to:
                                                        "/configuration/locale/" +
                                                        locale.locale +
                                                        "/auth",
                                                    },
                                                  },
                                                  [
                                                    _c("admin-icon", {
                                                      attrs: { name: "eye" },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.trans(
                                                            "auth.authentication"
                                                          )
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                locale.locale !== "en"
                                                  ? _c(
                                                      "b-dropdown-item-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "confirm",
                                                            rawName:
                                                              "v-confirm",
                                                            value: {
                                                              ok: _vm.confirmDelete(
                                                                locale
                                                              ),
                                                            },
                                                            expression:
                                                              "{ok: confirmDelete(locale)}",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "admin-row-actions__danger",
                                                      },
                                                      [
                                                        _c("admin-icon", {
                                                          attrs: {
                                                            name: "trash",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.trans(
                                                                "general.delete"
                                                              )
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    }),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "admin-table-pagination-wrap" },
                              [
                                _c("pagination-record", {
                                  attrs: {
                                    "page-length":
                                      _vm.filterLocaleForm.page_length,
                                    records: _vm.locales,
                                  },
                                  on: {
                                    "update:pageLength": function ($event) {
                                      return _vm.$set(
                                        _vm.filterLocaleForm,
                                        "page_length",
                                        $event
                                      )
                                    },
                                    "update:page-length": function ($event) {
                                      return _vm.$set(
                                        _vm.filterLocaleForm,
                                        "page_length",
                                        $event
                                      )
                                    },
                                    updateRecords: _vm.getLocales,
                                  },
                                  nativeOn: {
                                    change: function ($event) {
                                      return _vm.getLocales.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.locales && !_vm.locales.total
                      ? _c("module-info", {
                          attrs: {
                            module: "locale",
                            title: "module_info_title",
                            description: "module_info_description",
                            icon: "globe",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-locale-create",
            "hide-footer": "",
            centered: "",
            lazy: "",
            "modal-class": "admin-modal-pro",
            "content-class": "admin-modal-pro__content",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v(_vm._s(_vm.trans("locale.add_new_locale")))]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("locale-form", {
            on: {
              completed: _vm.getLocales,
              cancel: function ($event) {
                return _vm.$bvModal.hide("modal-locale-create")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-locale-add-word",
            "hide-footer": "",
            centered: "",
            lazy: "",
            "modal-class": "admin-modal-pro",
            "content-class": "admin-modal-pro__content",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.trans("locale.add_new_word")) +
                      "\n            "
                  ),
                  _c("show-tip", {
                    attrs: {
                      module: "locale",
                      tip: "tip_add_word",
                      type: "field",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "admin-linear-form",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.addWord.apply(null, arguments)
                },
                keydown: function ($event) {
                  return _vm.addWordForm.errors.clear($event.target.name)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "admin-linear-field" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.trans("locale.word")))]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.addWordForm.word,
                        expression: "addWordForm.word",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      value: "",
                      name: "word",
                      placeholder: _vm.trans("locale.word"),
                    },
                    domProps: { value: _vm.addWordForm.word },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.addWordForm, "word", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.addWordForm,
                      "prop-name": "word",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "admin-linear-field" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.trans("locale.module")))]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      name: "module",
                      id: "module",
                      options: _vm.modules,
                      placeholder: _vm.trans("locale.select_module"),
                    },
                    on: {
                      select: function ($event) {
                        return _vm.addWordForm.errors.clear("module")
                      },
                      remove: function ($event) {
                        _vm.addWordForm.module = ""
                      },
                    },
                    model: {
                      value: _vm.addWordForm.module,
                      callback: function ($$v) {
                        _vm.$set(_vm.addWordForm, "module", $$v)
                      },
                      expression: "addWordForm.module",
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.addWordForm,
                      "prop-name": "module",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "admin-linear-field" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.trans("locale.translation"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.addWordForm.translation,
                        expression: "addWordForm.translation",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      value: "",
                      name: "translation",
                      placeholder: _vm.trans("locale.translation"),
                    },
                    domProps: { value: _vm.addWordForm.translation },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.addWordForm,
                          "translation",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.addWordForm,
                      "prop-name": "translation",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "admin-linear-form__actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm admin-form-btn-cancel",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$bvModal.hide("modal-locale-add-word")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.trans("general.cancel")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                    attrs: { type: "submit" },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.trans("general.save")))])]
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }